module.exports = __webpack_public_path__ + "static/media/hospital-alt.8bcfbbb4.svg";